import React, { useEffect, useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";
import { Container, Canvas } from "./styled/telestrator";

function Telestrator({ strokeSize, color, lineDuration }) {
  const containerRef = useRef();
  const canvasRef = useRef();
  const svgRef = useRef();

  useLayoutEffect(() => {
    const handler = () => {
      if (!containerRef.current) return;
      const bodyRect = document.body.getBoundingClientRect();
      containerRef.current.style.width = `${bodyRect.width}px`;
      containerRef.current.style.height = `${bodyRect.height}px`;
    };
    handler();
    window.addEventListener("resize", handler);
    return () => {
      window.addEventListener("resize", handler);
    };
  }, []);

  useEffect(() => {
    let activeLine;
    let transition;

    function start() {
      if (transition) {
        d3.selectAll("#telestrator svg *").interrupt().style("opacity", 1);
      }

      activeLine = svgRef.current
        .append("path")
        .datum([])
        .attr("fill", "none")
        .attr("stroke", color)
        .attr("stroke-width", strokeSize)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round");
    }

    function drag() {
      const renderPath = d3
        .line()
        .x((d) => d[0])
        .y((d) => d[1])
        .curve(d3.curveBasis);

      activeLine.datum().push(d3.mouse(this));
      activeLine.attr("d", renderPath);
    }

    function end() {
      const lines = d3.selectAll("#telestrator svg *");

      transition = lines
        .transition()
        .on("end", () => lines.remove())
        .duration(lineDuration)
        .ease(d3.easeLinear)
        .style("opacity", 0);
    }

    svgRef.current = d3
      .select(canvasRef.current)
      .append("svg")
      .call(d3.drag().on("start", start).on("drag", drag).on("end", end));

    const handler = () =>
      d3.selectAll("#telestrator svg *").interrupt().remove();
    window.addEventListener("resize", handler);

    return () => {
      d3.selectAll("#telestrator svg").remove();
      window.addEventListener("resize", handler);
    };
  }, [strokeSize, color]);

  return (
    <Container ref={containerRef}>
      <Canvas ref={canvasRef} id="telestrator" />
    </Container>
  );
}

Telestrator.defaultProps = {
  strokeSize: 4,
  color: "#000",
  lineDuration: 5000
};

Telestrator.propTypes = {
  strokeSize: PropTypes.number,
  color: PropTypes.string,
  lineDuration: PropTypes.number
};

export default Telestrator;
